import React from "react"
import Drawer from "@mui/material/Drawer"
import List from "@mui/material/List"
import ListItem from "@mui/material/ListItem"
import ListItemText from "@mui/material/ListItemText"

import MenuDrawerItems from "./MenuDrawerItems"

interface MenuDrawerProps {
  drawerOpen: boolean
  handleRouteClicked: (route: string) => void
}

const MenuDrawer = ({ drawerOpen, handleRouteClicked }: MenuDrawerProps) => (
  <Drawer
    anchor="right"
    open={drawerOpen}
    onClose={handleRouteClicked}
    data-cy="menu-drawer"
  >
    <List>
      <MenuDrawerItems handleRouteClicked={handleRouteClicked} />
      <ListItem button onClick={() => handleRouteClicked("/profile")}>
        <ListItemText primary="Sign In" />
      </ListItem>
    </List>
  </Drawer>
)

export default MenuDrawer
